import React, { useState } from 'react';
import { Container, Row, Col, Modal } from 'react-bootstrap';
import CustomButton from './CustomButton/CustomButton';


const InsightsSection = () => {
  const awsImageBaseUrl = process.env.REACT_APP_AWS_IMAGE_BUCKET_URL; 
  const [showModal, setShowModal] = useState(false);
  const [modalBodyContent, setModalBodyContent] = useState(null);

  const handleOpenModal = (content) => {
    setModalBodyContent(content);
    setShowModal(true);
  };

  const handleClose = () => {
    setShowModal(false);
    setModalBodyContent(null);
  };

  const blogPostModalContent = (
    <div>
      <ul className="list-unstyled">
        <li className="mb-2">
          <a href="https://brandacumen.substack.com/p/the-future-of-name-validation-is" target="_blank" rel="noopener noreferrer" className="text-white text-decoration-underline">
            The Future of Name Validation
          </a>
        </li>
        <li className="mb-2">
          <a href="https://brandacumen.substack.com/p/naming-at-the-edge-the-linguistics" target="_blank" rel="noopener noreferrer" className="text-white text-decoration-underline">
            Naming at the Edge
          </a>
        </li>
        <li className="mb-2">
          <a href="https://brandacumen.substack.com/p/the-grammar-of-trust-what-makes-a" target="_blank" rel="noopener noreferrer" className="text-white text-decoration-underline">
            The Grammar of Trust: What Makes a Brand?
          </a>
        </li>
        <li className="mb-2">
          <a href="https://brandacumen.substack.com/p/the-emergence-of-ambient-brands-naming" target="_blank" rel="noopener noreferrer" className="text-white text-decoration-underline">
            The Emergence of Ambient Brands
          </a>
        </li>
      </ul>
    </div>
  );

  const insightsData = [
    {
      title: 'Blog Post',
      imageUrl: `${awsImageBaseUrl}images/blog_post.jpg`,
      actionType: 'modal',
      modalContent: blogPostModalContent,
    },
    {
      title: 'Video',
      imageUrl: `${awsImageBaseUrl}images/video.jpg`,
      actionType: 'link',
      link: '/brand-vault#resources',
    },
    {
      title: 'Report',
      imageUrl: `${awsImageBaseUrl}images/report.jpg`,
      actionType: 'link',
      link: '/brand-vault#resources',
    },
  ];

  return (
    <section className="py-3">
      <Container className="text-center">
        <Row className="mb-5">
          <Col xs={12}>
            <h2 className="font-bold text-black text-uppercase pt-5">
              Latest Insights
            </h2>
          </Col>
        </Row>

        <Row className="g-4 justify-content-center">
          {insightsData.map((item, index) => (
            <Col xs={12} sm={10} md={6} lg={4} key={index}>
              {item.actionType === 'modal' ? (
                <div
                  className="d-flex flex-column align-items-center img-radius h-100"
                  style={{ cursor: 'pointer' }} // Added inline style here
                  onClick={() => handleOpenModal(item.modalContent)}
                >
                  <div className="w-100 position-relative">
                    <img
                      src={item.imageUrl}
                      alt={item.title}
                      className="img-fluid img-radius w-100"
                      loading="lazy"
                    />
                    <div className="position-absolute top-0 start-0 w-100 h-100 bg-black bg-opacity-25 overlay-gradient-bottom img-radius"></div>
                    <div className="position-absolute top-0 start-0 ms-3 mt-3 text-white font-bold fs-4">
                      {item.title}
                    </div>
                  </div>
                </div>
              ) : (
                <a href={item.link} className="text-decoration-none text-dark">
                  <div className="d-flex flex-column align-items-center img-radius h-100">
                    <div className="w-100 position-relative">
                      <img
                        src={item.imageUrl}
                        alt={item.title}
                        className="img-fluid img-radius w-100"
                        loading="lazy"
                      />
                      <div className="position-absolute top-0 start-0 w-100 h-100 bg-black bg-opacity-25 overlay-gradient-bottom img-radius"></div>
                      <div className="position-absolute top-0 start-0 ms-3 mt-3 text-white font-bold fs-4">
                        {item.title}
                      </div>
                    </div>
                  </div>
                </a>
              )}
            </Col>
          ))}
        </Row>

        <Row className="mt-5 justify-content-center">
          <Col xs="auto">
            <CustomButton
              label="SEE HOW WE CAN HELP YOU"
              variant="red"
              size="small"
              href="/what-we-do"
              target=""
            />
          </Col>
        </Row>

        <Modal
          show={showModal}
          onHide={handleClose}
          centered
          size="md"
          contentClassName="bg-black text-white position-relative text-sm img-radius"
        >
          <Modal.Header className="border-0 px-5">
            <button
              type="button"
              onClick={handleClose}
              className="btn position-absolute top-0 end-0"
              style={{ fontSize: '3rem', color: 'red', background: 'none', border: 'none', marginTop:'-21px' }}
              aria-label="Close"
            >
              &times;
            </button>
          </Modal.Header>
          <Modal.Body>
            <div className="container-fluid">
              <div className="row">
                <div className="col">
                  {modalBodyContent || "No content available"}
                </div>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </Container>
    </section>
  );
};

export default InsightsSection;